<template>
  <div
    class="public-page-item-section"
    :class="{ highlighted, 'pointer-events-none': !url }"
    @click.stop
  >
    <div class="public-page-item-text usn">
      {{ descriptionText }}
    </div>
    <div
      v-if="url || showLinkSection"
      class="flex items-center gap-2"
    >
      <div
        class="public-page-item-text public-page-link"
        :class="{ 'w-full': showLinkSection, 'disabled-public-link': !url }"
      >
        <span
          class="url-text"
          :class="{ 'w-full': showLinkSection }"
          >{{ url }}</span
        >
        <div
          class="copy-link-button pt"
          @click.stop="copyUrl"
          @touchstart.stop
        >
          <em
            :style="getCustomIconStyle(iconPath('link-st'))"
            :class="{ 'bg-inactive-icon': !url }"
            class="custom-icons copy-public-link-icon"
          />
        </div>
      </div>
      <a
        v-if="showOpenPublicResourceURL"
        target="_blank"
        rel="noopener"
        class="public-link"
        :class="{
          'bg-inactive-bg border-inactive-border': !url,
        }"
        :href="url"
      >
        <em
          :style="getCustomIconStyle(iconPath('external-link'))"
          :class="{ 'bg-inactive-icon': !url }"
          class="external-link-icon custom-icons"
        />
      </a>
    </div>
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import { ResourceType } from '@/types/resources';

export default {
  name: 'PublicPageListItem',

  mixins: [customIconsMixin],

  props: {
    url: {
      type: String,
      required: true,
    },
    highlighted: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'page',
    },
    showLinkSection: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    descriptionText() {
      return this.type === ResourceType.Note
        ? this.translate('anyoneWithThisLinkCanViewNote')
        : this.translate('publishesSubpagesButNoComments');
    },
    showOpenPublicResourceURL() {
      return this.type === ResourceType.Note;
    },
  },

  methods: {
    copyUrl() {
      if (!this.url) return;

      navigator.clipboard.writeText(this.url);

      this.$store.dispatch('addUiNotification', {
        message: this.translate('linkCopiedToClipboard'),
        icon: 'link-st',
        duration: 4000,
      });
    },
  },
};
</script>

<style lang="scss">
.public-page-item-section {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 0px 16px 8px;

  &.highlighted {
    @apply bg-important-hover;
  }

  .public-page-item-text {
    font-size: 12px;
    line-height: 18px;
    @apply text-text-default;

    &.public-page-link {
      height: 30px;
      display: flex;
      align-items: center;
      border: 1px solid;
      box-sizing: border-box;
      overflow: hidden;
      @apply border-important-border bg-important-bg text-text-default rounded;

      .copy-link-button {
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid;
        padding: 7px;
        @apply border-dividers-default;

        &:hover {
          @apply bg-important-hover;

          .copy-public-link-icon {
            @apply bg-icon-default;
          }
        }
      }

      .url-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 24px;
        padding: 0px 8px 0px 13px;
      }
    }
  }

  .public-link {
    @apply flex p-1.5 bg-important-bg rounded border border-solid border-important-border box-border;

    .external-link-icon {
      @apply w-4 h-4;
    }

    &:hover {
      @apply bg-important-hover;
    }
  }

  .disabled-public-link {
    background-color: var(--inactiveElementBg) !important;
    border-color: var(--inactiveElementBorder) !important;
  }
}
</style>
